import { configureStore } from "@reduxjs/toolkit";
import { companySlice } from "./slices/companySlice";
import { contactSlice } from "./slices/contactSlice";
import { productsSlice } from "./slices/productSlice";

export const store = configureStore({
  reducer: {
    company: companySlice.reducer,
    products: productsSlice.reducer,
    contact: contactSlice.reducer,
  },
});
